var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/trash")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/trash",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,3.5 L12,3.5 L12,13.5 C12,14.6045695 11.1045695,15.5 10,15.5 L4,15.5 C2.8954305,15.5 2,14.6045695 2,13.5 L2,3.5 L2,3.5 Z",
    id: "Rectangle",
    stroke: "#154B82",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0.5 L10,0.5 L10,1.5 C10,2.6045695 9.1045695,3.5 8,3.5 L6,3.5 C4.8954305,3.5 4,2.6045695 4,1.5 L4,0.5 L4,0.5 Z",
    id: "Rectangle",
    stroke: "#154B82",
    fill: "#FFFFFF",
    transform: "translate(7.000000, 2.000000) scale(1, -1) translate(-7.000000, -2.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5882353,3 C13.8156467,3 14,3.22385763 14,3.5 C14,3.74545989 13.8543381,3.94960837 13.6622505,3.99194433 L13.5882353,4 L0.411764706,4 C0.184353338,4 0,3.77614237 0,3.5 C0,3.25454011 0.145661897,3.05039163 0.337749479,3.00805567 L0.411764706,3 L13.5882353,3 Z",
    id: "Line",
    fill: "#154B82",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 6.5,
    x2: 4.5,
    y2: 12.5,
    id: "Line-2",
    stroke: "#154B82",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 6.5,
    x2: 7,
    y2: 12.5,
    id: "Line-2",
    stroke: "#154B82",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 6.5,
    x2: 9.5,
    y2: 12.5,
    id: "Line-2",
    stroke: "#154B82",
    strokeLinecap: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.4b4f40fe.svg";
export { ForwardRef as ReactComponent };